<template>
  <div>
    <h1>Relatórios</h1>
    <div class="content events">
      <div class="subtitle">
        <h2>Valores por lote</h2>
      </div>
      <table v-if="showData">
        <thead>
          <tr>
            <th>Lote</th>
            <th>Valor unitário</th>
            <th>Quantidade validada</th>
            <th>Total</th>
          </tr>
        </thead>
      <tfoot>
        <tr>
          <td>Total</td>
          <td></td>
          <td>{{ totalAmount | number }}</td>
          <td>{{ totalCurrency | currency }}</td>
        </tr>
      </tfoot>
        <tbody>
          <tr v-for="value in response.values" :key="value.id">
            <td>{{ value.name }}</td>
            <td>{{ value.unitary_currency | currency }}</td>
            <td>{{ value.validate_amount | number }}</td>
            <td>{{ value.validate_currency | currency }}</td>
          </tr>
        </tbody>
      </table>

      <div class="subtitle">
        <h2>Ingressos validados</h2>
      </div>
      <values-chart v-if="showData"
        :height="100"
        :labels="chartValuesLabels"
        :values="chartValuesValues">
      </values-chart>

      <div class="subtitle">
        <h2>Horários das entradas</h2>
      </div>
      <entrance-chart v-if="showData"
        :height="100"
        :labels="chartEntranceLabels"
        :values="chartEntranceValues">
      </entrance-chart>
    </div>
  </div>
</template>

<script>
import EntranceChart from './EntranceChart'
import ValuesChart from './ValuesChart'

export default {
  name: 'Report',
  components: {
    'entrance-chart': EntranceChart,
    'values-chart': ValuesChart
  },
  data () {
    return {
      chartEntranceValues: [],
      chartEntranceLabels: [],
      chartValuesValues: [],
      chartValuesLabels: [],
      response: null,
      totalCurrency: null,
      totalAmount: null,
      showData: false
    }
  },
  mounted () {
    this.$http.get(process.env.VUE_APP_URL_APP + '/b/events/' + this.$route.params.id + '/reports').then(res => {
      this.response = res.body

      this.$_.each(res.body.entrances, (value) => {
        this.chartEntranceLabels.push(value.hour + ':00 - ' + value.hour + ':15')
        this.chartEntranceValues.push(value.first_quarter)

        this.chartEntranceLabels.push(value.hour + ':16 - ' + value.hour + ':30')
        this.chartEntranceValues.push(value.second_quarter)

        this.chartEntranceLabels.push(value.hour + ':31 - ' + value.hour + ':45')
        this.chartEntranceValues.push(value.third_quarter)

        this.chartEntranceLabels.push(value.hour + ':46 - ' + value.hour + ':59')
        this.chartEntranceValues.push(value.fourth_quarter)
      })

      this.$_.each(res.body.values, (value) => {
        this.chartValuesLabels.push(value.name)
        this.chartValuesValues.push(value.validate_amount)

        this.totalCurrency += value.validate_currency
        this.totalAmount += value.validate_amount
      })

      this.showData = true
    }, err => {
      console.error(err)
    })
  },
  filters: {
    number (value) {
      return this.$numeral(value).format('0,0')
    },
    currency (value) {
      let v = value / 100
      return 'R$ ' + this.$numeral(v).format('0,0.00')
    }
  }
}
</script>

<style>

</style>
